import React from 'react';

import axios from 'axios';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';

import Alert from '@material-ui/lab/Alert';

import { withStyles } from '@material-ui/core/styles';

import { Config } from '../../Config';

const styles = theme => ({
    paper: {
        marginTop: theme.spacing(8),
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    button: {
        margin: theme.spacing(3, 0, 2),
        fontWeight: 'bold'
    },
})

class Login extends React.Component {
    constructor() {
        super()
        this.state = {
            input_username: '',
            input_password: '',

            error_username: false,
            error_password: false,

            alert: false
        }
    }

    onChangeHandler = event => {
        this.setState({ [event.target.name]: event.target.value })

        if (event.target.name === 'input_username') {
            this.setState({ error_username: false })
        }
        else if (event.target.name === 'input_password') {
            this.setState({ error_password: false })
        }
    }

    onBlurHandler = event => {
        if (event.target.value === '') {
            if (event.target.name === 'input_username') {
                this.setState({ error_username: true })
            }
            else if (event.target.name === 'input_password') {
                this.setState({ error_password: true })
            }
        }
    }

    loginHandler = event => {
        //prevent the page from refreshing during submit action
        event.preventDefault()
        event.stopPropagation()

        axios.post(Config() + '/authentication/login',
            {
                'username': this.state.input_username,
                'password': this.state.input_password
            })
            .then(response => {
                console.log(response.data[0])
                if (response.data[0] === "OK") {
                    sessionStorage.setItem('status', 'login')
                    sessionStorage.setItem('is_admin', response.data[1])
                    this.goAuthHome()
                }
            })
            .catch(error => {
                if (error.response.status === 403) {
                    this.setState({
                        alert: true,
                        alertText: "Invalid username or password."
                    })
                }
                else {
                    console.log(error)
                }
            })
    }

    goBack = () => {
        this.props.history.push({
            pathname: '/'
        })
    }

    goAuthHome = () => {
        this.props.history.push({
            pathname: '/Home'
        })
    }

    render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                <Container component="main" maxWidth="xs" style={{ height: '100%' }}>
                    <CssBaseline />

                    <Paper className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            <LockOutlinedIcon />
                        </Avatar>

                        <Typography component="h1" variant="h5">
                            Sign in
                        </Typography>

                        <form className={classes.form} noValidate>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                label="Username"
                                name="input_username"
                                autoComplete="username"
                                // autoFocus
                                value={this.state.input_username}
                                onChange={this.onChangeHandler}
                                onBlur={this.onBlurHandler}
                                error={this.state.error_username}
                                helperText={this.state.error_username ? 'Username cannot be empty!' : null}
                            />

                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="input_password"
                                label="Password"
                                type="password"
                                autoComplete="current-password"
                                value={this.state.input_password}
                                onChange={this.onChangeHandler}
                                onBlur={this.onBlurHandler}
                                error={this.state.error_password}
                                helperText={this.state.error_password ? 'Password cannot be empty!' : null}
                            />

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={this.loginHandler}
                            >
                                Sign In
                            </Button>
                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.button}
                                onClick={this.goBack}
                            >
                                Back to Home
                            </Button>
                        </form>

                        {this.state.alert ?
                            <Alert severity="error">
                                {this.state.alertText}
                            </Alert>
                            :
                            null
                        }
                    </Paper>

                </Container>
            </React.Fragment>
        )
    }
}

export default withStyles(styles, { withTheme: true })(Login);